import clsx from "clsx";
import PropTypes from "prop-types";
import "./radio-group.scss";

export const RadioGroup = ({
  children,
  className = "",
  label,
  labelClassName = "",
}) => (
  <fieldset className={clsx("ha-radio-group", className)}>
    <legend className={clsx("ha-radio-group-label", labelClassName)}>
      {label}
    </legend>
    {children}
  </fieldset>
);

RadioGroup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  labelClassName: PropTypes.string,
};
